import Card from "./Card";
import Detail from "./Detail";
import Hero from "./Hero";
import Link from "./Link";
import Meta from "./Meta";
import TagList from "./TagList";
import Title from "./Title";
import VariantList from "./VariantList";

export default {
  Card,
  Detail,
  Hero,
  Link,
  Meta,
  TagList,
  Title,
  VariantList
};
